export const ISO_YYYY_MM_DD = 'yyyy-MM-dd'

export const ISO_HH_MM_SS = 'HH:mm:ss'

export const YYYY_MM_DD_JP = 'yyyy年MM月dd日'

export const YYYY_MM_JP = 'yyyy年MM月'

export const YYYY_MM = 'yyyyMM'

export const MM_DD_JP = 'MM月dd日'

export const HH_MM_JP = 'HH時mm分'

export const YYYY_MM_DD_HH_MM_JP = 'yyyy年MM月dd日 HH:mm'

export const YYYY_MM_DD_SLASH = 'yyyy/MM/dd'

export const YYYY_MM_DD_HH_MM_SLASH = 'yyyy/MM/dd HH:mm'

export const HH_MM = 'HH:mm'
